import React from 'react';
import { useSelector } from 'react-redux';
import { Flex, Text, Image } from 'rebass';
import styled from 'styled-components';
import jobsIcon from 'assets/icons/jobs.png';
import search from 'assets/icons/search.png';
import candidatesImg from 'assets/icons/candidates.png';
import candidate from 'assets/icons/candidate.png';
import Link from 'components/Link';
import colors from 'theme/colors';
import { RECRUITERS } from '../content';
import Notifications from './Notifications';

// Components
import DashBoardStatisticItem from './DashBoardStatisticItem';
import useWaitForLeavingDashboard from '../hooks/useWaitForLeavingDashboard';

const BlockWrapper = styled(Flex)`
  border: 2px solid ${colors.darkGray};
  padding: 30px 30px 40px;
  white-space: pre-wrap;
  min-height: 230px;
`;

const RecruiterDashBoard: React.FC = (): JSX.Element => {
  useWaitForLeavingDashboard();
  const { jobs, candidates } = useSelector<any, any>(state => state.statistics);

  return (
    <Flex width="100%" flexDirection="column">
      <Notifications content={RECRUITERS} />
      <Flex justifyContent="space-between">
        <BlockWrapper width="calc(50% - 15px)">
          <Flex>
            <Flex alignItems="flex-start">
              <Image src={jobsIcon} />
            </Flex>
            <Flex flexDirection="column" ml={1}>
              <Text fontSize="25px" fontWeight={6} lineHeight={1} mb={3}>
                {RECRUITERS.jobs.title}
              </Text>
              {!jobs.active && !jobs.watching && (
                <>
                  <Text fontSize="20px" fontWeight={5} lineHeight={1.5} mb={4}>
                    {RECRUITERS.jobs.subtitle}
                  </Text>
                  <Flex alignItems="center">
                    <Image src={search} />
                    <Link
                      to="/"
                      color={colors.green}
                      hover={colors.green}
                      fontSize="18px"
                      ml={1}
                      css="font-weight: 600"
                    >
                      {RECRUITERS.jobs.searchLink}
                    </Link>
                  </Flex>
                </>
              )}
              {!!jobs.active && (
                <DashBoardStatisticItem to="/job-posts">
                  {jobs.active} active
                </DashBoardStatisticItem>
              )}
              {!!jobs.watching && (
                <DashBoardStatisticItem to="/job-posts">
                  {jobs.watching} watching
                </DashBoardStatisticItem>
              )}
            </Flex>
          </Flex>
        </BlockWrapper>
        <BlockWrapper width="calc(50% - 15px)" flexDirection="column">
          <Flex>
            <Flex alignItems="flex-start">
              <Image src={candidatesImg} />
            </Flex>
            <Flex flexDirection="column" ml={1}>
              <Text fontSize="25px" fontWeight={6} lineHeight={1} mb={3}>
                {RECRUITERS.candidates.title}
              </Text>
              {!candidates.total && (
                <>
                  <Text fontSize="20px" fontWeight={5} lineHeight={1.5} mb={4}>
                    {RECRUITERS.candidates.subtitle}
                  </Text>
                  <Flex width="100%" justifyContent="space-between" css="max-width: 380px;">
                    <Flex alignItems="center">
                      <Image src={candidate} />
                      <Link
                        to="/new-candidates"
                        color={colors.green}
                        hover={colors.green}
                        fontSize="18px"
                        ml={1}
                        css="font-weight: 600"
                      >
                        {RECRUITERS.candidates.newCandidatesLink}
                      </Link>
                    </Flex>
                  </Flex>
                </>
              )}
              {!!candidates.total && (
                <DashBoardStatisticItem>
                  {candidates.total} candidates in total
                </DashBoardStatisticItem>
              )}
              {!!candidates.active && (
                <DashBoardStatisticItem>{candidates.active} active</DashBoardStatisticItem>
              )}
              {!!candidates.pending && (
                <DashBoardStatisticItem>{candidates.pending} pending</DashBoardStatisticItem>
              )}
            </Flex>
          </Flex>
        </BlockWrapper>
      </Flex>
    </Flex>
  );
};

export default RecruiterDashBoard;
